import React from "react";
import { Route, Routes } from "react-router-dom";
import { SimpleLayout } from "../components/simpleLayout";

// ROTAS
import { TermosConfirmacaoLogin } from "../pages/termos/confirmacaoLogin";

const TermosRoutes = () => {
  return (
    <SimpleLayout>
      <Routes>
        <Route path="*" element={<TermosConfirmacaoLogin />} />
      </Routes>
    </SimpleLayout>
  );
};

export { TermosRoutes };
